module.exports = __webpack_public_path__ + "img/w6.9979d408.png";